class FilteringCapabilitiesDto {
    Id: number;
    Label: string;
    Key: string;
    Type: number;
    Operators: number;
    IsRequired: boolean;

    constructor(id: number, label: string, key: string, type: number, operators: number, isRequired: boolean) {
        this.Id = id;
        this.Label = label;
        this.Key = key;
        this.Type = type;
        this.Operators = operators;
        this.IsRequired = isRequired;
    }
}

export default FilteringCapabilitiesDto;
